import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Login from 'components/dashboard/Auth/Login';
import 'antd/dist/antd.css';
import EditPost from 'components/dashboard/Post/EditPost';
import ListPost from 'components/dashboard/Post/ListPost';
import PrivateRoute from './HOC/PrivateRoute';
import AddPost from 'components/dashboard/Post/AddPost';

const App = ({ dispatch }) => {
  useEffect(() => {}, [dispatch]);
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Login} />
        <PrivateRoute exact path="/posts/create" component={AddPost} />
        <PrivateRoute exact path="/posts" component={ListPost} />
        <PrivateRoute exact path="/posts/:id" component={EditPost} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
